export default __webpack_public_path__ + "static/media/Inter-UI-MediumItalic.66ad5409.woff2";